import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext.jsx';
import { IAChatProvider } from '../../contexts/IAChatContext.jsx';
import ConversationList from '../../components/ia/ConversationList.jsx';
import ChatPanel from '../../components/ia/ChatPanel.jsx';

/**
 * Vista de página completa del Asistente IA — puerto Tailwind de
 * `IbuFront/src/components/views/AsistenteIA/AsistenteIAPage.jsx` (V1). Se monta en
 * la ruta `/asistente-ia` (ya declarada en `Sidebar.jsx`, gateada por
 * `asistente-ia:usar`; falta registrarla en `App.jsx`, ver bloque en el reporte
 * final — este archivo NO edita `App.jsx` por regla de la tarea).
 *
 * Monta su PROPIO `IAChatProvider` (no depende del que `ChatWidget.jsx` monta en
 * `AppLayout.jsx`, que además se auto-oculta en esta misma ruta) — así la página
 * funciona standalone si se navega directo a la URL.
 *
 * Gateo de permiso: si el usuario no tiene `asistente-ia:usar`, se muestra un aviso
 * en vez del chat (la ruta en sí no está protegida por un guard de permiso propio —
 * ver `App.jsx`/`PrivateRoute.jsx`, que sólo verifica sesión, no permisos por
 * recurso; el resto de páginas de ResourcePage resuelven esto vía
 * `hasPermiso` dentro del propio componente, mismo patrón aquí).
 */
export default function AsistenteIAPage() {
  const { hasPermiso } = useContext(AuthContext);

  if (!hasPermiso('asistente-ia:usar')) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-slate-500 text-sm">No tienes permiso para usar el Asistente IA.</p>
      </div>
    );
  }

  return (
    <IAChatProvider>
      <div className="card flex" style={{ height: 'calc(100vh - 140px)', overflow: 'hidden' }}>
        <div className="hidden sm:block border-r border-slate-200 flex-shrink-0" style={{ width: 260 }}>
          <ConversationList />
        </div>
        <div className="flex-grow min-w-0">
          <ChatPanel />
        </div>
      </div>
    </IAChatProvider>
  );
}
